import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringSplit',
})
export class StringSplitPipe implements PipeTransform {
  transform(text: string, splitChar: string, partIndex: number): any {
    if (text == null || splitChar == null) {
      return '';
    }
    if (text.includes(splitChar)) {
      const textparts = text.split(splitChar);
      try {
        const value = textparts[partIndex];
        return value;
      } catch {
        return text;
      }
    } else {
      return text;
    }
  }
}
